import React from 'react';
import './Authorization.scss';
import Registration from "../Authorization/Registration/Registration";
import Login from "../Authorization/Login/Login";
import Recovery from './Recovery/Recovery';
import RecoveryPass from './RecoveryPass/RecoveryPass';

import Activation from "../Authorization/Activation/Activation";
import {openRegistrationForm, openLoginForm, logout, getInitialState} from '../Authorization/authSlice';
import { getInitialStateData } from '../FirstMain/userSlice';
//import Example1 from '../Example_Promises';

const Authorization= (props) => {
    const {dispatch} = props;

    //RENDER COMPONENT
  const renderRegistration = () => {
    return (
    <Registration 
      dispatch={dispatch}
      userData={props.userData}
      />
    );
  };

//LOGIN COMPONENT
const renderLogin = () => {
  return (
  <Login 
    dispatch={dispatch}
    userData={props.userData}
    />
  );
};
//ACTIVATION COMPONENT
const renderActivation = () => {
  return (
  <Activation 
    dispatch={dispatch}
    userData={props.userData}
    />
  );
};

    //RENDER RECOVERY
  const renderRecovery = () => {
    return (
    <Recovery
      dispatch={dispatch}
      userData={props.userData}
      />
    );
  };
    //RENDER RECOVERY PASS
  const renderRecoveryPass = () => {
    return (
    <RecoveryPass
      dispatch={dispatch}
      userData={props.userData}
      />
    );
  };


// HANDLER
const onSend = () => {

    dispatch(logout());
    dispatch(getInitialState());
    dispatch(getInitialStateData());
}

const render = () =>{
    if (props.userData.email) {
        return (
            <div className="Authorization">
            <h3>Пользователь {props.userData.email}</h3>
            <button onClick = {() => onSend()}>Выход</button>
            
            </div>
          );
         
    } else {
        return (
            <div className="Authorization">
              <p> Вход в WSCproject</p>
              {props.userData.userMessageForRecovery ? <p className='message'>{props.userData.userMessageForRecovery}</p> : null}
            <button className='loginButton' onClick = {() => dispatch(openLoginForm())}>Войти</button>
            <button className='registrationButton' onClick = {() => dispatch(openRegistrationForm())}>Регистрация</button>
            <p className='description'>После регистрации вы получите доступ ко всем возможностям сайта</p>
            <p className='mark'>© 2013-2026 WSCproject </p>
            {/*<Example1 dispatch={dispatch} />*/}

            </div>
          );
    }
    
   
}



    if (props.userData.openRegistrationForm === true) {
        return renderRegistration();
    }
    if (props.userData.openLoginForm === true) {
      return renderLogin();
  }
    if (props.userData.openActivationForm === true) {
      return renderActivation();
    }
     if (props.userData.openRecoveryForm === true) {
      return renderRecovery();
    }
    
    if (props.userData.openRecoveryPassForm === true) {
      return renderRecoveryPass();
    }
  
    
    return render(); 
  }
  
  export default Authorization;